var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "h1",
    {
      staticClass: "titleClass",
      class: _vm.$vuetify.theme.dark ? "title_dark" : "title_light",
      staticStyle: { "padding-top": "30px" },
    },
    [
      _vm.icon.length > 0
        ? _c(
            "v-icon",
            {
              class: _vm.$vuetify.theme.dark ? "title_dark" : "title_light",
              staticStyle: { "font-size": "23px" },
              attrs: { left: "" },
            },
            [_vm._v(_vm._s(_vm.icon) + " ")]
          )
        : _vm._e(),
      _vm._v(" " + _vm._s(_vm.title) + " "),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }